const listeners = new Set();

export const subscribeToNotifications = (listener) => {
  if (typeof listener !== 'function') {
    return () => {};
  }

  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const emitNotification = (notification) => {
  if (!notification || typeof notification !== 'object') {
    return;
  }

  listeners.forEach((listener) => {
    try {
      listener(notification);
    } catch (_error) {
      // Ignore listener failures to keep notifications resilient.
    }
  });
};

export const emitErrorNotification = (message, options = {}) => {
  emitNotification({
    severity: 'error',
    message,
    ...options
  });
};

export const emitSuccessNotification = (message, options = {}) => {
  emitNotification({
    severity: 'success',
    message,
    ...options
  });
};
